import { Constants, mockConstants, JsonStringDates, parseConstantsJson, setClientServerTimeOffset, parseEasternTimeDate } from 'portal2-models'

export const getConstants = async () => {
	const response = await fetch('/api/constants')

	let constants = mockConstants

	try {
		const serverConstants = await response.json() as JsonStringDates<Constants>
		const serverDate = parseEasternTimeDate(serverConstants.environmentInfo.currentEasternTimeStamp)
		setClientServerTimeOffset(serverDate)

		constants = parseConstantsJson(serverConstants)
	}
	catch {
		console.error("Failed to retrieve constants from server")
	}

	return constants
}
